import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export default function EmptyTransaction() {
  return (
    <Stack
      alignItems="center"
      direction="column"
      py="40px"
      spacing="8px"
    >
      <Text
        color="tertiary"
        size="xl"
        weight="medium"
      >
        You don’t have any transactions yet
      </Text>
    </Stack>
  );
}
